import { Message, Loading } from "element-ui";
import router from "@/router/index";
import Cookies from "js-cookie";
import store from "@/store/index";
import i18n from "../../public/languages/i18n";

export async function MessageSuccess(val) {
  Message({
    message: val,
    type: "success",
    center: true,
    showClose: true,
  });
}
export function MessageError(val) {
  Message({
    message: val,
    type: "error",
    center: true,
    showClose: true,
  });
}

export function MessageWarning(val) {
  Message({
    message: val,
    type: "warning",
    center: true,
    showClose: true,
  });
}

export function MessageInfo(val) {
  Message({
    message: val,
    type: "info",
    center: true,
    showClose: true,
  });
}

export function OpenLoading() {
  let loadingInstance = Loading.service({
    lock: true,
    // text: '正在加载...',
    text: "loading...",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  setTimeout(() => {
    loadingInstance.close();
  }, 2000);
  return loadingInstance;
}

export function startLoading() {
  let loadingInstance = Loading.service({
    lock: true,
    // text: '正在加载...',
    text: "loading...",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  setTimeout(() => {
    loadingInstance.close();
  }, 10000);
  return loadingInstance;
}
export function nfstartLoading() {
  let loadingInstance = Loading.service({
    lock: true,
    // text: '正在加载...',
    text: "loading...",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  setTimeout(() => {
    loadingInstance.close();
  }, 10000);
  return loadingInstance;
}

export function aminuteLoading() {
  let loadingInstance = Loading.service({
    lock: true,
    // text: '正在加载...',
    text: "loading...",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  setTimeout(() => {
    loadingInstance.close();
  }, 60000);
  return loadingInstance;
}

export function getUserInfo() {
  startLoading().close();
  let deadline = Cookies.get("deadline");
  let userInfo = Cookies.get("userInfo");
  let token = Cookies.get("token");
  if (!deadline || !userInfo || !token) {
    removeInfo();
        // router.push('login');
    // 修改
    if ("ontouchstart" in document.documentElement) {
      // return this.$router.push({ name: "phonelogin" });
      //router.push("phonelogin");
      //router.push({ name:'phonelogin' })
      router.push({path:'/phone'})
    } else {
      // return this.$router.push({ path: "login" });
      //router.push("login");
      router.push({ path:'/backhome' })
    }
  } else {
    let now = new Date().getTime();
    if (deadline < now) {
      removeInfo();
      // router.push('login');
      // 修改
      if ("ontouchstart" in document.documentElement) {
        // return this.$router.push({ name: "phonelogin" });
        //router.push("phonelogin");
        router.push({ path:'/phone' })
      } else {
        // return this.$router.push({ path: "login" });
        //router.push("login");
        router.push({ path:'/backhome' })
      }
    }
  }
  return userInfo;
}
export function removeInfo() {
  Cookies.remove("userInfo");
  Cookies.remove("deadline");
  Cookies.remove("token");
  if (localStorage.lang == "kr") {
    store.commit("setMenuListData", store.state.map.menuListLogin);
  } else if (localStorage.lang == "it") {
    store.commit("setMenuListData", store.state.map.menuListLoginIt);
  } else if (localStorage.lang == "ar") {
    store.commit("setMenuListData", store.state.map.menuListLoginAr);
  } else if (localStorage.lang == "es") {
    store.commit("setMenuListData", store.state.map.menuListLoginEs);
  }
  else if (localStorage.lang == "fr") {
    store.commit("setMenuListData", store.state.map.menuListLoginFr);
  }
  // else if (localStorage.lang=='en'){
  else {
    store.commit("setMenuListData", store.state.map.menuListLoginEn);
  }
  return null;
}


export function isEmpty(val) {
  if (val == "" || val == undefined || val == null) {
    return true;
  } else {
    if(Array.isArray(val)&&val.length == 0){
      return true;
    }else {
      return false;
    }

  }
}

export function filterObj(ary, key, value) {
  var obj = "";
  if (ary != null && ary.length > 0 && value !== '') {
    ary.forEach((item) => {
      if (item[key] == value) {
        obj = item;
        return false;
      }
    });
  }
  return obj
}

export function filterObjGetIndex(ary, key, value) {
  var obj = "";
  if (ary != null && ary.length > 0 && value != '') {
    ary.forEach((item, index) => {
      if (item[key] == value) {
        obj = index;
        return false;
      }
    });
  }

  return obj
}

export function formatObj(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function downLoadFile(url, fileName) {
  var request = new XMLHttpRequest();
  request.responseType = "blob";
  request.open("GET", url);
  request.onload = function() {
    var url = window.URL.createObjectURL(this.response);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url
    a.download = fileName;
    a.click();
  }
  request.send();
}

export function formatDate(date) {
  let startTime = date.getMonth() + 1;
  let endTime = date.getDate();
  if(startTime<10){
    startTime = '0'+startTime;
  }
  if(endTime<10){
    endTime = '0'+endTime;
  }
  return `${startTime}-${endTime}`;
}

export function checkIfToday(givenTime) {
  // 获取当前日期
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  // 解析给定时间
  const givenDate = new Date(givenTime);
  const givenYear = givenDate.getFullYear();
  const givenMonth = givenDate.getMonth();
  const givenDay = givenDate.getDate();

  // 比较日期
  return (
      currentYear === givenYear &&
      currentMonth === givenMonth &&
      currentDay === givenDay
  );
}

let languageCode = "en";
let languageList = [
  {
    code: 'kr',
    name: '한국어'
  },
  {
    code: 'en',
    name: 'English'
  },
  {
    code: 'es',
    name: 'Spanish'
  },
  {
    code: 'it',
    name: 'italian'
  },
  {
    code: 'ar',
    name: 'عربي'
  },
  {
    code: 'fr',
    name: 'Français'
  }
];
let yesOrNo = [
  {
    //是
    value:1,
    label: i18n.t('order.yes')
  },
  {
    //否
    value:0,
    label: i18n.t('order.no')
  }
];
let pcActiveTab = "home";
let phoneActiveTab = "phonehome";
let imgPrefix = 'https://alongshare.oss-eu-west-1.aliyuncs.com';
export default {
  languageCode,
  languageList,
  yesOrNo,
  pcActiveTab,
  phoneActiveTab,
  imgPrefix
}



